__turbopack_context__.v({
  "active": "treeSelect-module-scss-module__uPd-nq__active",
  "arrowIcon": "treeSelect-module-scss-module__uPd-nq__arrowIcon",
  "disable": "treeSelect-module-scss-module__uPd-nq__disable",
  "iconWrapper": "treeSelect-module-scss-module__uPd-nq__iconWrapper",
  "isChildOption": "treeSelect-module-scss-module__uPd-nq__isChildOption",
  "isHidden": "treeSelect-module-scss-module__uPd-nq__isHidden",
  "isOpen": "treeSelect-module-scss-module__uPd-nq__isOpen",
  "isParentWithoutChildren": "treeSelect-module-scss-module__uPd-nq__isParentWithoutChildren",
  "multiValueWithCountryFlag": "treeSelect-module-scss-module__uPd-nq__multiValueWithCountryFlag",
  "option": "treeSelect-module-scss-module__uPd-nq__option",
  "optionContainer": "treeSelect-module-scss-module__uPd-nq__optionContainer",
  "removeIcon": "treeSelect-module-scss-module__uPd-nq__removeIcon",
  "selected": "treeSelect-module-scss-module__uPd-nq__selected",
});
